



import {Component, Prop} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ValidationFormMixin} from "@/mixins";

import TextInput from "@/components/Atoms/TextInput/TextInput.vue";
import TextInputGroup from "@/components/Molecules/TextInputGroup/TextInputGroup.vue";
import AuthCard from "@/components/Organisms/AuthCard/AuthCard.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";
import CheckBox from "@/components/Atoms/CheckBox/CheckBox.vue";
import ButtonOutlineSuccessful from "@/components/Atoms/ButtonOutlineSuccessful/ButtonOutlineSuccessful.vue";
import CardHeader from "@/components/Atoms/CardHeader/CardHeader.vue";
import {LoginFormType} from "@/share";
import {CHECKBOX_STATUS} from "@/constants";

@Component({
  components: {
    TextInput,
    TextInputGroup,
    AuthCard,
    ButtonSuccessful,
    CheckBox,
    ButtonOutlineSuccessful,
    CardHeader
  }
})
export default class LoginForm extends mixins(ValidationFormMixin) {
  @Prop({type: Boolean, default: false}) isLoading!: boolean
  @Prop({type: String, default: ''}) error!: string


  public formData: LoginFormType = new LoginFormType({
    email: '',
    password: '',
    rememberMe: CHECKBOX_STATUS.UN_ACCEPTED
  })

  private changeEmail(value: string) {
    this.formData.email = value
  }

  private changePassword(value: string) {
    this.formData.password = value
  }

  private async submit(): Promise<void> {
    const isValid = await this.validateForm()
    if (!isValid) return

    this.$emit('submit', this.formData)
  }

  private onClickButtonSignUp() {
    this.$router.push({name: 'routes.auth.register'})
  }

  private onClickButtonForgotPass() {
    this.$router.push({name: 'routes.auth.forgotPassword'})
  }

  private onChangeCheckbox(value: number) {
    this.formData.rememberMe = value
  }
}
